<template>
  <v-list-item class="course-steps-list-item rounded-lg bhWhite mb-3">
    <v-list-item-icon class="align-self-center mr-4" v-if="!readonly">
      <v-icon
        color="bhBlack"
        class="rounded-circle bhGray5 course-steps-list-item__drag-handle"
        size="8"
        >bhi-drag-dots</v-icon
      >
    </v-list-item-icon>
    <v-list-item-avatar
      width="56"
      height="56"
      rounded
      :class="
        `course-steps-list-item__thumbnail mr-3 ${
          hasFile ? 'course-steps-list-item__thumbnail--selected' : ''
        }`
      "
    >
      <v-img
        :src="thumbnail"
        :lazy-src="require('@/assets/placeholder_other.png')"
        :alt="title"
        :key="`course-step-list-item-thumbnail-${id}-${thumbnailKey}`"
        @error="onThumbnailError"
        @load="onThumbnailSuccess"
        @click="showPreview"
      >
        <template v-slot:placeholder>
          <div class="d-flex align-center fill-height justify-center">
            <v-progress-circular
              indeterminate
              color="accent"
            ></v-progress-circular>
          </div>
        </template>
        <v-icon
          v-if="isVideoType"
          size="24"
          color="bhWhite"
          class="course-steps-list-item__play-icon"
          >bhi-play-circle</v-icon
        >
      </v-img>
    </v-list-item-avatar>
    <v-list-item-content
      class="py-2 course-steps-list-item__content"
      @click="openEdit"
    >
      <v-list-item-title class="course-steps-list-item__title">{{
        title
      }}</v-list-item-title>
      <v-list-item-subtitle class="course-steps-list-item__description">{{
        description
      }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action
      class="course-steps-list-item__actions d-flex flex-row align-center my-2"
      v-if="!readonly"
    >
      <v-btn icon color="bhGray2" elevation="0" @click="openDelete">
        <v-icon>bhi-trash</v-icon>
      </v-btn>
      <!-- <v-btn icon color="bhGray2" elevation="0" @click="openEdit">
        <v-icon>bhi-pencil</v-icon>
      </v-btn> -->
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { debounce } from '@/helpers/debounce'
import globalPreviewMediaMixin from '@/mixins/globalPreviewMedia'
import { getFileTypeByUrl } from '@/helpers/chat'
export default {
  components: {},
  name: 'CourseStepsListItem',
  mixins: [globalPreviewMediaMixin],
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
    },
    description: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    attachmentUrl: {
      type: String,
      default: '',
    },
    thumbnailUrl: {
      type: String,
      default: '',
    },
    mediaUrl: {
      type: String,
      default: '',
    },
    staticMediaThumbnailUrl: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    isThumbnailError: false,
    thumbnailKey: 0,
    isVideoType: false,
  }),
  computed: {
    thumbnail() {
      if (this.isThumbnailError) {
        const { type } = getFileTypeByUrl(this.thumbnailUrl || this.mediaUrl)
        if (type === 'image') {
          return require('@/assets/placeholder_image.png')
        }
        if (type === 'video') {
          return require('@/assets/placeholder_video.png')
        }
        if (type === 'pdf') {
          return require('@/assets/placeholder_pdf.png')
        }
        return require('@/assets/placeholder_other.png')
      }
      return (
        this.staticMediaThumbnailUrl ||
        this.thumbnailUrl ||
        // this.mediaUrl ||
        require('@/assets/placeholder_other.png')
      )
    },
    hasFile() {
      return !!(
        this.staticMediaThumbnailUrl ||
        this.thumbnailUrl ||
        this.mediaUrl
      )
    },
  },
  methods: {
    onThumbnailSuccess() {
      this.isThumbnailError = false
      this.thumbnailKey = 0
      this.isVideoType = false
      const { type } = getFileTypeByUrl(this.mediaUrl)

      if (type === 'video') {
        this.isVideoType = true
      }
    },
    onThumbnailError() {
      if (this.thumbnailKey >= 3) {
        this.isThumbnailError = true
        if (this.thumbnailUrl) {
          this.$emit('refresh-course-step-media')
        }
        return
      }
      debounce(
        () => {
          this.thumbnailKey++
        },
        5000,
        `REFRESH_COURSE_STEP_THUMBNAIL_${this.id}`,
      )
    },
    openEdit() {
      this.$emit('open-edit', {
        title: this.title,
        id: this.id,
        description: this.description,
        link: this.link,
        thumbnailUrl: this.thumbnailUrl,
        mediaUrl: this.mediaUrl,
        staticMediaThumbnailUrl: this.staticMediaThumbnailUrl,
        attachmentUrl: this.attachmentUrl,
      })
    },
    openDelete() {
      this.$emit('open-delete', {
        title: this.title,
        id: this.id,
        description: this.description,
        link: this.link,
        thumbnailUrl: this.thumbnailUrl,
        mediaUrl: this.mediaUrl,
        staticMediaThumbnailUrl: this.staticMediaThumbnailUrl,
        attachmentUrl: this.attachmentUrl,
      })
    },
    showPreview() {
      if (this.hasFile) {
        this.openGlobalPreviewMedia({
          mediaUrl:
            this.staticMediaThumbnailUrl || this.mediaUrl || this.thumbnailUrl,
          imageName: null,
          mlResourceUrl: null,
          fileTypeId: null,
        })
      }
    },
  },
}
</script>

<style lang="scss">
.course-steps-list-item {
  &__drag-handle {
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
  &__title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
  }
  &__content {
    cursor: pointer !important;
  }
  &__description {
    font-size: 12px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: pre-line;
  }
  &__thumbnail--selected {
    cursor: pointer;
  }
  &__play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
}
</style>
